import { z } from "zod";
export const companyListItemSchema = z.object({
    idcompany: z.number(),
    name: z.string(),
    country: z.string().nullable(),
    plan: z.string().nullable(),
    status: z.string().nullable(),
    channelCount: z.number().default(0),
    lastActivityAt: z.string().nullable(),
});
export const companyDetailSchema = companyListItemSchema.extend({
    distributor: z.string().nullable(),
    createdAt: z.string().nullable(),
    notesCount: z.number().default(0),
});
export const companyNoteSchema = z.object({
    id: z.number(),
    idcompany: z.number(),
    authorId: z.number().nullable(),
    authorName: z.string().nullable(),
    body: z.string(),
    pinned: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const createCompanyNoteSchema = z.object({
    body: z.string().min(1).max(4000),
    pinned: z.boolean().default(false),
});
//# sourceMappingURL=company.js.map